import { render, staticRenderFns } from "./CreateMailboxModal.vue?vue&type=template&id=2fa11e7a&scoped=true"
import script from "./CreateMailboxModal.vue?vue&type=script&lang=js"
export * from "./CreateMailboxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa11e7a",
  null
  
)

export default component.exports